export default __webpack_public_path__ + "static/caribbean-0010039f08fc51fd930e424f5df0634a.svg";